// extracted by mini-css-extract-plugin
export default {"regionsPage":"RegionsPage_regionsPage__AWIPP","regionsGrid":"RegionsPage_regionsGrid__P1PLT","region":"RegionsPage_region__bcFCs"};